export const HERO_PRIMARY_SUB = 'Документ';
export const HERO_DISCORD_SUB = 'Сообщество';
export const HERO_SWITCHER_LABEL = 'Раздел';
export const HERO_LOCATION_LABEL = 'Локация';
